module.exports = __webpack_public_path__ + "assets/img/eztourlogo.4d315e5.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/eztourlogo.png
// module id = 908
// module chunks = 39